import jwtDecode from 'jwt-decode'
export default function getInfoUserFromTokens() {
  const idToken = localStorage.getItem('idToken')
  const accessToken = localStorage.getItem('accessToken')
  const profile = jwtDecode(idToken)
  const access = jwtDecode(accessToken)
  const scope = access.scope
  const scopeArray = scope.split(' ')
  const adminRole = scopeArray.filter(item => item.includes('avl:ADMINROLE'))
  let roleToSend = ''
  if (adminRole.length === 0) {
    roleToSend = scopeArray.filter(item => item.includes('avl:ROLE'))[0]
  } else roleToSend = adminRole[0]
  return {
    email: profile['https://omnitrack.com.co/email'],
    whoId: profile['sub'],
    whoName: profile['name'],
    roleToSend
  }
}



// WEBPACK FOOTER //
// ./src/utils/getInfoUserFromTokens.js